import http from "./HttpService";
import { API_BASE_CONTENT } from "../../constants/index";
import { getVersionId } from "modules/EmailBrowser/utils";
import { getCSRFToken } from "utils";

export function getMostEngagedService(limit = 0, offset = 0) {
  const version_id = getVersionId();
  return http.get(
    API_BASE_CONTENT +
      "get_content_engagement/?version_id=" +
      version_id +
      "&limit=" +
      limit +
      "&offset=" +
      offset,
    { headers: { "X-CSRFToken": getCSRFToken() } }
  );
}
